module.exports = {
  fr: {
    title: "Consultez notre blog",
    subtitle: "Nos clients et partenaires sont à l'honneur sur le blog. Découvrez également les événements couverts par nos chauffeurs privés.",
  },
  en: {
    title: "Visit our blog",
    subtitle: "Our customers and partners are honored on the blog. Also discover the events covered by our private drivers.",
  },
  ru: {
    title: "Посмотрите наш блог",
    subtitle: "Наши клиенты и партнеры выполняются в блоге. Также ознакомьтесь с событиями, которые распространяются нашими частными драйверами.",
  },
  de: {
    title: "Unser Blog",
    subtitle: "Unsere Kunden und Partner stehen im Mittelpunkt unseres Blogs. Entdecken Sie auch die Veranstaltungen, die unsere Privatchauffeure begleiten."
  },
  it: {
    title: "Visita il nostro blog",
    subtitle: "Sul blog diamo spazio ai nostri clienti e partner. Scopri anche gli eventi seguiti dai nostri autisti privati."
  },
  es: {
    title: "Visite nuestro blog",
    subtitle: "Nuestros clientes y socios son los protagonistas del blog. Descubra también los eventos que acompañan nuestros chóferes privados."
  }
};
